module.exports = __webpack_public_path__ + "img/AT0000026736650.70aabb7d.png";